export enum FeatureFlag {
  DashboardCustomRoles = 'dashboard-custom-roles',
  EnableAchPositivePay = 'enable-ach-positive-pay-apis',
  EnableAchTransferBatches = 'enable-ach-transfer-batches',
  EnableCustomCSVStatements = 'enable-custom-csv-statements',
  EnableDeviceMFA = 'enable-device-mfa',
  EnableExpeditedCheckDelivery = 'enable-expedited-check-delivery',
  EnableExternalApps = 'enable-external-apps',
  EnableLoanSearch = 'enable-loan-search',
  EnableNotificationConfiguration = 'enable-notification-configuration',
  EnablePaniniCheckScanner = 'enable-panini-check-scanner',
  EnablePasskeyAuth = 'enable-passkey-auth',
  EnableRealtimeTransferApprovals = 'enable-realtime-transfer-approvals',
  EnableSwiftTransferApprovals = 'enable-swift-transfer-approvals',
  EnableTransferApprovals = 'enable-transfer-approvals',
  EnableTransferApprovalPage = 'enable-transfer-approval-page',
  EnableTransferBatches = 'enable-transfer-batches',
  EnableTransferSearch = 'enable-transfer-search',
  HasInternationalWires = 'has-international-wires',
}
